import React from 'react';
import ChatConsoleView from 'component/organism/chat-console/ChatConsoleView';

import styles from './ChatConsole.module.scss';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useUserContext } from 'app-context/user/UserContext';

const ChatConsole = ({ disableConsole, isUserChat = false }) => {
  const { brandingData } = useBrandingContext();
  const { selectedBot } = useUserContext();
  const { page_TextColor, page_BackgroundColor } = brandingData;

  return (
    <div
      className={`chat-console-root ${styles['chat-console']}`}
      style={{ backgroundColor: page_BackgroundColor, color: page_TextColor }}
    >
      {selectedBot?.botId || isUserChat ? (
        <ChatConsoleView
          bot={selectedBot?.botId}
          disableConsole={disableConsole}
          ChatSource={2}
          isUserChat={isUserChat}
        />
      ) : null}
    </div>
  );
};

export default ChatConsole;
